

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'tools_';

export default {
  path: routePre + '/tools',
  name: 'tools',
  header: 'tools',
  redirect: {
    name: `${pre}toolsQuote`,
  },
  component: LayoutMain,
  children: [
	
	
	{
	  path: 'quote',
	  name: `${pre}toolsQuote`,
	  meta: {
	    auth: ['tools-quote'],
	    title: '名额申请表',
	  },
	  component: () => import('@/pages/tools/quote/index'),
	},
	
	{
	  path: 'work',
	  name: `${pre}toolsWork`,
	  meta: {
	    auth: ['tools-work'],
	    title: '兼职表',
	  },
	  component: () => import('@/pages/tools/work/index'),
	},
	
	{
	  path: 'job',
	  name: `${pre}toolsJob`,
	  meta: {
	    auth: ['tools-job'],
	    title: '兼职发布平台',
	  },
	  component: () => import('@/pages/tools/job/index'),
	},
	
	{
	  path: 'website',
	  name: `${pre}toolsWebsite`,
	  meta: {
	    auth: ['tools-website'],
	    title: '官网',
	  },
	  component: () => import('@/pages/tools/website/index'),
	},
	
	{
	  path: 'stages',
	  name: `${pre}toolsStages`,
	  meta: {
	    auth: ['tools-stages'],
	    title: '分期申请',
	  },
	  component: () => import('@/pages/tools/stages/index'),
	},
	
	{
	  path: 'report',
	  name: `${pre}toolsReport`,
	  meta: {
	    auth: ['tools-report'],
	    title: '企业微信防封',
	  },
	  component: () => import('@/pages/tools/report/index'),
	},
	
	{
	  path: 'teaching',
	  name: `${pre}toolsTeachingIndex`,
	  meta: {
	    auth: ['tools-teaching'],
	    title: '讲师列表',
	  },
	  component: () => import('@/pages/tools/teaching/teacher/index'),
	},
	{
	  path: 'teaching/teacher',
	  name: `${pre}toolsTeachingTeacher`,
	  meta: {
	    auth: ['tools-teaching-teacher'],
	    title: '讲师管理',
		activeMenu: routePre + '/tools/teaching',
	  },
	  component: () => import('@/pages/tools/teaching/teacher/teacher'),
	},
	
	{
	  path: 'teaching/teacher/update',
	  name: `${pre}toolsTeachingTeacher`,
	  meta: {
	    auth: ['tools-teaching-teacher'],
	    title: '编辑讲师',
		activeMenu: routePre + '/tools/teaching',
	  },
	  component: () => import('@/pages/tools/teaching/teacher/update'),
	},
  ],
};
